import { LangTranslate } from "../../types/types";
import { api } from "./api";
import { UpdateTranslationsRequest } from "../types/translate.types";

export const adminApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTranslation: build.query<LangTranslate[], string>({
      query: (text) => ({
        url: `/AI/AI_Translate?text=${text}`,
        method: "GET",
      }),
    }),

    saveTranslation: build.mutation<boolean, UpdateTranslationsRequest>({
      query: (request) => ({
        url: `/Languages/Update`,
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const {
  useLazyGetTranslationQuery,
  useSaveTranslationMutation,
} = adminApi;
